import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { STATIC_ROOT } from '../../../../constants';
import {
    IBAN_TYPE_PERSONNAL,
    IBAN_TYPE_RELATIVE
} from '../../../../services/account/iban/constants';
import { MODAL_TYPE_DELETE_IBAN } from '../../../../services/modal/constants';

import { showModal } from '../../../../services/modal/actions';
import { fetchIbanIfNeeded } from '../../../../services/account/iban/actions';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import SvgComponent from '../../../SvgComponent';
import { LoadingComponent } from '../../../loading/LoadingComponent';

import './IbanListComponent.scss';

export class IbanListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showForm: false };
    }

    componentDidMount() {
        this.props.fetchIbanIfNeeded();
    }

    showDeleteIbanModal = iban => {
        const { i18n, showModal } = this.props;

        showModal(MODAL_TYPE_DELETE_IBAN, {
            id: 'iban-delete-modal',
            ariaLabel: format(i18n.DELETE_MODAL_LABEL, this.renderIbanLabel(iban)),
            iban: iban
        });
    };

    renderIbanLabel = iban => {
        const { i18n } = this.props;

        if (iban.label) {
            return iban.label;
        } else if (iban.firstname || iban.lastname) {
            const name = `${iban.firstname ? iban.firstname : ''} ${
                iban.lastname ? iban.lastname : ''
            }`;
            return convertHtmlToReactDomWithParams(i18n.ACCOUNT_OF, name);
        } else {
            return iban.iban;
        }
    };

    handleDelete = iban => {
        this.showDeleteIbanModal(iban);
    };

    handleKeyDown = (e, iban) => {
        if (e.key === 'Enter') {
            this.handleDelete(iban);
        }
    };

    getTitle() {
        const { i18n, type } = this.props;

        if (type === IBAN_TYPE_PERSONNAL) {
            return i18n.REGISTER_ACCOUNT_PERSONNAL;
        } else if (type === IBAN_TYPE_RELATIVE) {
            return i18n.REGISTER_ACCOUNT_OTHER;
        } else {
            return i18n.REGISTER_ACCOUNT;
        }
    }

    render() {
        const { i18n, type, ibans, ibansFetching } = this.props;
        const ibanType = type ? type : IBAN_TYPE_RELATIVE;

        return (
            <div className="account-wrapper" id="ibanList">
                <h2>{this.getTitle()}</h2>

                {ibansFetching ? (
                    <LoadingComponent />
                ) : (
                    ibans &&
                    ibans
                        .filter(iban => iban.type === ibanType)
                        .map(iban => {
                            return (
                                <div className="account" key={iban.id}>
                                    <div className="delete">
                                        <span
                                            id={`del-iban-${iban.id}`}
                                            title={convertHtmlToReactDomWithParams(
                                                i18n.DELETE_TEXT,
                                                this.renderIbanLabel(iban)
                                            )}
                                            aria-label={convertHtmlToReactDomWithParams(
                                                i18n.DELETE_TEXT,
                                                this.renderIbanLabel(iban)
                                            )}
                                            role="button"
                                            tabIndex="0"
                                            onClick={() => this.handleDelete(iban)}
                                            onKeyDown={e => this.handleKeyDown(e, iban)}>
                                            <SvgComponent
                                                src={`${STATIC_ROOT}/trash.svg`}
                                                alt=""
                                                width="16"
                                                height="20"
                                                aria-hidden="true"
                                                focusable="false"
                                            />
                                        </span>
                                    </div>
                                    <div className="text">
                                        <p className="label">{this.renderIbanLabel(iban)}</p>
                                        <p>
                                            {convertHtmlToReactDomWithParams(
                                                i18n.IBAN_NUMBER,
                                                iban.iban
                                            )}
                                        </p>
                                        {iban.bic && (
                                            <p>
                                                {convertHtmlToReactDomWithParams(
                                                    i18n.BIC_CODE,
                                                    iban.bic
                                                )}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            );
                        })
                )}
            </div>
        );
    }
}

IbanListComponent.propTypes = {
    type: PropTypes.number
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.PROFILE.IBAN,
        ibans: state.account.iban.ibans,
        ibansFetching: state.account.iban.fetching
    };
};

const mapDispatchToProps = {
    fetchIbanIfNeeded,
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(IbanListComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/IbanListComponent.js